import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  grid-area: quantity;\n  min-width: 120px;\n  margin: 0 15px;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  grid-area: unitPrice;\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n--bs-blue: #4e9cff;\n--bs-orange: #ff9f0c;\n--bs-cyan: #30beff;\n--bs-gray: #526872;\n--bs-gray-dark: #35434a;\n--bs-default: #a8b6bc;\n--bs-theme: #3cd2a5;\n--bs-primary: #4e9cff;\n--bs-secondary: #798e98;\n--bs-warning: #ff9f0c;\n--bs-danger: #ff6060;\n--bs-success: #3cd2a5;\n--bs-info: #30beff;\n--bs-dark: #35434a;\n--bs-black: #000000;\n--bs-white: #FFFFFF;\n--bs-purple: #de8cff;\n--bs-indigo: #bba4ff;\n--bs-red: #ff6060;\n--bs-pink: #f34fa0;\n--bs-green: #1ecc33;\n--bs-yellow: #f9e80d;\n--bs-teal: #3cd2a5;\n--bs-muted: #617a86;\n--bs-light: #c0cacf;\n--bs-lime: #81f32d;\n--bs-gray-100: #c0cacf;\n--bs-gray-200: #a8b6bc;\n--bs-gray-300: #90a2aa;\n--bs-gray-400: #798e98;\n--bs-gray-500: #617a86;\n--bs-gray-600: #526872;\n--bs-gray-700: #44555e;\n--bs-gray-800: #35434a;\n--bs-gray-900: #273136;\n--bs-default-rgb: 168, 182, 188;\n--bs-theme-rgb: 60, 210, 165;\n--bs-primary-rgb: 78, 156, 255;\n--bs-secondary-rgb: 121, 142, 152;\n--bs-warning-rgb: 255, 159, 12;\n--bs-danger-rgb: 255, 96, 96;\n--bs-success-rgb: 60, 210, 165;\n--bs-info-rgb: 48, 190, 255;\n--bs-dark-rgb: 53, 67, 74;\n--bs-purple-rgb: 222, 140, 255;\n--bs-indigo-rgb: 187, 164, 255;\n--bs-red-rgb: 255, 96, 96;\n--bs-pink-rgb: 243, 79, 160;\n--bs-green-rgb: 30, 204, 51;\n--bs-yellow-rgb: 249, 232, 13;\n--bs-teal-rgb: 60, 210, 165;\n--bs-muted-rgb: 97, 122, 134;\n--bs-light-rgb: 192, 202, 207;\n--bs-lime-rgb: 129, 243, 45;\n--bs-gray-100-rgb: 192, 202, 207;\n--bs-gray-200-rgb: 168, 182, 188;\n--bs-gray-300-rgb: 144, 162, 170;\n--bs-gray-400-rgb: 121, 142, 152;\n--bs-gray-500-rgb: 97, 122, 134;\n--bs-gray-600-rgb: 82, 104, 114;\n--bs-gray-700-rgb: 68, 85, 94;\n--bs-gray-800-rgb: 53, 67, 74;\n--bs-gray-900-rgb: 39, 49, 54;\n--bs-white-rgb: 255, 255, 255;\n--bs-black-rgb: 0, 0, 0;\n--bs-body-color-rgb: 255, 255, 255;\n--bs-body-bg-rgb: 39, 49, 54;\n--bs-font-sans-serif: system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n--bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n--bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));\n--bs-body-font-family: Chakra Petch, sans-serif;\n--bs-body-font-size: 0.875rem;\n--bs-body-font-weight: 400;\n--bs-body-line-height: 1.5;\n--bs-body-color: rgba(255, 255, 255, 0.75);\n--bs-body-bg: #273136;\n--blue: #007bff;\n--indigo: #6610f2;\n--purple: #6f42c1;\n--pink: #e83e8c;\n--red: #dc3545;\n--orange: #fd7e14;\n--yellow: #ffc107;\n--green: #28a745;\n--teal: #20c997;\n--cyan: #17a2b8;\n--white: #fff;\n--gray: #6c757d;\n--gray-dark: #343a40;\n--breakpoint-xs: 0;\n--breakpoint-sm: 576px;\n--breakpoint-md: 768px;\n--breakpoint-lg: 992px;\n--breakpoint-xl: 1200px;\n--font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n--font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n--primary: #a3ff12;\n--secondary: #5e627e;\n--tertiary: #222430;\n--success: #88df00;\n--info: #ced0da;\n--warning: #ffcc00;\n--danger: #ff1c5c;\n--light: #fff;\n--dark: #151515;\n-webkit-text-size-adjust: 100%;\n-webkit-tap-highlight-color: transparent;\ntext-align: left;\ncolor: #ffffff !important;\nmargin: 0;\npadding: 0;\nborder: 0;\nfont: inherit;\nvertical-align: baseline;\nbox-sizing: border-box;\ndisplay: flex;\n-webkit-box-align: center;\nalign-items: center;\n-webkit-box-pack: center;\njustify-content: center;\ngrid-area: trash;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  grid-area: trash;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n    p {\n      text-align: right;\n    }\n  "]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  grid-area: totalPrice;\n  ", "\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n  ", "\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    font-weight: normal;\n    flex-direction: column;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  display: flex;\n  justify-content: center;\n  font-weight: bold;\n  ", "\n\n  p {\n    margin: 0;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: rgba(125, 125, 125, 0.6);\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: ", ";\n  text-align: left;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  flex-grow: 1;\n  display: flex;\n  justify-content: flex-start;\n  white-space: nowrap;\n  background-color: white;\n  padding: 0px 15px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n    flex-flow: column;\n  "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-auto-columns: max-content;\n  grid-template-columns: repeat(auto-fit, minmax(166px, 500px));\n  margin-left: -15px;\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin: 6px 0;\n  text-align: left;\n  margin-bottom: 10px;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    margin-left: 0px;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  grid-area: description;\n  height: 100%;\n  margin-top: 20px;\n  margin-left: 20px;\n  ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  grid-area: photo;\n  display: flex;\n  align-items: flex-start;\n  align-self: top;\n  width: 70px;\n  height: 90px;\n\n  background-color: #f1f5f5;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  padding: 0;\n  margin: 0 15px 0 0;\n  width: 50px;\n\n  > div {\n    display: flex;\n  }\n\n  svg {\n    cursor: pointer;\n    justify-self: center;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-template-columns: 1fr 2fr 2fr;\n    grid-row-gap: 15px;\n    grid-column-gap: 20px;\n    grid-template-areas: \"photo description description\"\n    \"trash description description\"\n    \"trash unitPrice quantity\"\n    \". . totalPrice\";\n    padding: 1rem 0rem;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  min-height: 140px;\n  max-height: min-content;\n  width: 100%;\n  grid-template-areas: \"photo description unitPrice quantity totalPrice trash\";\n  grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr 0.5fr;\n  align-items: center;\n  border-bottom: 1px solid rgba(50, 50, 50, 0.1);\n  padding: 0.8rem 0.5rem;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { media, styled } from "@styles";
export var Wrapper = styled.div(_templateObject(), media.mediumScreen(_templateObject2()));
export var QuantityButtons = styled.div(_templateObject3());
export var Photo = styled.div(_templateObject4());
export var Description = styled.div(_templateObject5(), media.mediumScreen(_templateObject6()));
export var Sku = styled.p(_templateObject7());
export var Attributes = styled.div(_templateObject8(), media.mediumScreen(_templateObject9()));
export var SingleAttribute = styled.p(_templateObject10());
export var Name = styled.p(_templateObject11(), function (props) {
  return props.theme.typography.boldFontWeight;
}, function (props) {
  return props.theme.typography.h4FontSize;
});
export var LightFont = styled.span(_templateObject12(), function (props) {
  return props.theme.typography.smallFontSize;
});
export var Price = styled.div(_templateObject13(), function (props) {
  return props.theme.typography.h4FontSize;
}, media.mediumScreen(_templateObject14()));
export var PriceLabel = styled.p(_templateObject15(), media.mediumScreen(_templateObject16()));
export var TotalPrice = styled(Price)(_templateObject17(), media.mediumScreen(_templateObject18()));
export var Trash = styled.div(_templateObject19());
export var UnitPrice = styled(Price)(_templateObject20());
export var Quantity = styled.div(_templateObject21());